import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class ChannelCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
		this._isMounted = true;

        API.Biz.get('/retail/customers/query/getChannels', {},
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.channelName, value: item.channelId } })
                 });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={false}
                ref={(c) => { this._ctrl = c}} />)
    }
}

export default ChannelCombo;

// Mark this as a form component
ChannelCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/channelCombo/ChannelCombo.js